import React from 'react';
import { usePathname } from '@framework/next/navigation';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import LoginModalSection from '@framework/ui/Pages/Landing/Sections/LoginModal';
import styles from './loginModal.module.scss';
import { AUTO_SEND_ACCESS_REQUEST, AUTO_SEND_FOLLOW } from '@dataroom/datarooms/contexts/accessRequestConstants';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

const features = [
  'Request Access to issuer documentation without lengthy approval cycles',
  'Easily explore new issuers who have opted to share their information',
  'Leverage email upload notifications to stay on top of your portfolio',
];
const title = 'Streamline your research process with instant access to deal docs';
const explanation = 'This feature requires you to log in using your free CreditFlow account.';

interface IProps {
  isVisible: boolean,
  tenant: DataroomTenant,
  dataroomId: number,
  dataroomName: string,
  autoSendAction: string,
  afterClose: () => void,
  closeOnEsc: boolean,
  showCloseButton: boolean,
}

const LoginModal = (props: IProps) => {
  let autoSendUrl;
  if (props.autoSendAction === AUTO_SEND_FOLLOW) {
    autoSendUrl = dataroomUrl(props.tenant).getFollowUrl(props.dataroomId);
  } else if (props.autoSendAction === AUTO_SEND_ACCESS_REQUEST) {
    autoSendUrl = dataroomUrl(props.tenant).getAccessRequestUrl(props.dataroomId, props.dataroomName);
  } else if (props.isVisible) {
    throw new Error('Unsupported autoSendAction.');
  }

  const pathname = usePathname();

  return (
    <LoginModalSection
      { ...props }
      title={ title }
      features={ features }
      className={ styles.modalWrp }
      titleClassName={ styles.titleWrp }
      featuresClassName={ styles.featuresWrp }
      buttonClassName={ styles.buttonWrp }
      loginUrl={ dataroomUrl(props.tenant).getLoginUrl(autoSendUrl!) }
      registerUrl={ dataroomUrl(props.tenant).getRegisterUrl(
        dataroomUrl(props.tenant).getUrl(pathname),
      ) }
    >
      <div className={ styles.explanation }>{ explanation }</div>
    </LoginModalSection>
  );
};

export default LoginModal;
